import { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import 'react-quill/dist/quill.snow.css';
import "react-quill/dist/quill.snow.css";
import { useLoading } from '../../../context/LoadingContext';
import { HiShoppingCart } from "react-icons/hi2";
import { FaEye } from "react-icons/fa6";
import React from 'react'
import { FaBoxOpen,FaClipboardCheck, FaTimes, FaCheckCircle, FaCreditCard, FaCommentAlt} from "react-icons/fa";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import { FaTrash,FaSave} from "react-icons/fa";


function ManageOrder() {
const invoiceRef = useRef(null);
  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
 
  const [searchTerm, setSearchTerm] = useState('');
  const [manageOrder, setManageOrder] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [formItems, setFormItems] = useState({
    batch_no: '',
    mfg: '',
    exp: '',
    item: '',
  })


  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const[selectedPartyId,setSelectedPartyId] = useState('');
const [remark, setRemarks] = useState("");
const [paymentId, setPaymentId] = useState("");

  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
const [editItems, setEditItems] = useState([]);

    const [form, setForm] = useState({
    coupon_name: '',
    coupon_code: '',
    state: '',
    city: '',
    discount_type: '',
    discount_value: '',
    order_value: '',
  })

    const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const statusOptions = [
    { value: "Dispatched", label: "Dispatched" },
    { value: "Shipped", label: "Shipped" },
    { value: "Out For Delivery", label: "Out For Delivery" },
    { value: "Delivered", label: "Delivered" },

    { value: 'Refund Initiated', label: 'Refund Initiated' },
    { value: 'Refund Processed', label: 'Refund Processed' },
    { value: 'Refund Completed', label: 'Refund Completed' },

    { value: 'Return Initiated', label: 'Return Initiated' },
    { value: 'Return Processed', label: 'Return Processed' },
    { value: 'Return Completed', label: 'Return Completed' },

    { value: 'Exchange Initiated', label: 'Exchange Initiated' },
    { value: 'Exchange Processed', label: 'Exchange Processed' },
    { value: 'Exchange Completed', label: 'Exchange Completed' },

      { value: 'Return Initiated', label: 'Return Initiated' },
    { value: 'Return Processed', label: 'Return Processed' },
    { value: 'Return Completed', label: 'Return Completed' },
    { value: 'Return Denied ', label: 'Return Denied ' },

     { value: 'Refund Requested ', label: 'Refund Requested ' },
      { value: 'Return Requested ', label: 'Return Requested ' },

  ];

  const getStatusOptions = () => {

  if (!selectedOrder) return [];

  const status = manageOrder.order_status;

 

  if (status === "Dispatched") {
    return [
      { value: "Shipped", label: "Shipped" },
      { value: "Out For Delivery", label: "Out For Delivery" }
    ];
  }

  if (status === "Shipped") {
    return [
      { value: "Out For Delivery", label: "Out For Delivery" }
    ];
  }

  if (status === "Out For Delivery") {
    return [
      { value: "Delivered", label: "Delivered" }
    ];
  }

  if (status === "Delivered") {
    return [
      { value: "Return Initiated", label: "Return Initiated" },
      { value: "Exchange Initiated", label: "Exchange Initiated" }
    ];
  }

  if (status === "Return Initiated") {
    return [
      { value: "Return Processed", label: "Return Processed" }
    ];
  }

  return statusOptions;
};



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };




const handleStatusUpdate = async () => {
  if (!selectedStatus) {
    showToast("Please select a status", "warning");
    return;
  }

  try {
  // exchange case is pedning 


    if ( selectedStatus === "Refund Completed") {
      if (!paymentId.trim()) {
        showToast("Please enter Payment ID", "warning");
        return;
      }

    
         await axios.put(`https://api.skyguard.group/api/update-exchange-return-status/${selectedOrderId}`, {
        payment_id: paymentId.trim(),
        order_status: selectedStatus,
        remark: remark.trim() || null, 
      }); 


      showToast("Payment and status updated successfully", "success");
    } 

     if ( selectedStatus === "Return Completed") {
      if (!paymentId.trim()) {
        showToast("Please enter Payment ID", "warning");
        return;
      }

    

         await axios.put(`https://api.skyguard.group/api/update-exchange-return-status/${selectedOrderId}`, {
        payment_id: paymentId.trim(),
        order_status: selectedStatus,
        remark: remark.trim() || null, 
      });


      showToast("Payment and status updated successfully", "success");
    } 
  
    else {
      await axios.put(`https://api.skyguard.group/api/update-order-status/${selectedOrderId}`, {
        order_status: selectedStatus,
        remark: remark.trim() || null,
      });

      showToast("Status updated successfully", "success");
    }

  
    setShowStatusModal(false);
    setSelectedStatus("");
    setRemarks("");
    setPaymentId("");

    fecthOrders();
  } catch (error) {
    console.error("Status update error:", error);
    showToast("Failed to update status", "danger");
  }
};


  const fecthOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-orders');

      const sortedOrders = Array.isArray(res.data)
        ? [...res.data].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
        : res.data;
      setManageOrder(sortedOrders);
  

      const ordersWithItemCount = res.data.map(order => {
        return {
          ...order,
          itemsCount: Array.isArray(order.items) ? order.items.length : 0
        };

   
      });

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthOrders();

  }, []);





  const filteredData = manageOrder.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )


  const handleDownloadInvoice = async () => {
  if (!invoiceRef.current) {
    console.error("Invoice element not found");
    return;
  }

  const element = invoiceRef.current;

  const options = {
    margin: 0,
    filename: `Order-Invoice-${selectedOrder?.id || "invoice"}.pdf`,

    image: {
      type: "jpeg",
      quality: 0.98
    },

    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false
    },

    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait"
    }
  };

  try {
    await html2pdf()
      .set(options)
      .from(element)
      .save();
  } catch (error) {
    console.error("Invoice PDF generation error:", error);
  }
};
  


const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const orderTotal = calculateEditOrderTotal();

    const response = await axios.put(
      `https://api.skyguard.group/api/update-order-items/${form.id}`,
      {
        items: editItems,
        order_total: orderTotal
      }
    );

    showToast(
      response.data?.message ||
      "Items updated successfully"
    );

    setShowForm(false);
    setIsEditMode(false);
    setEditItems([]);


    fecthOrders();

  } catch (error) {

    console.error(
      "Update item error:",
      error
    );

    showToast(
      error.response?.data?.error ||
      "Failed to update items"
    );
  }
};




const handleEdit = (order) => {
  let itemsArray = [];

  try {
    itemsArray = order.items
      ? JSON.parse(order.items)
      : [];
  } catch (error) {
    console.error("Failed to parse items:", error);
  }

  // Keep every item key exactly as received
  setEditItems(itemsArray);

  // Keep the original order information
  setForm({
    id: order.id || "",
    party_id: order.party_id || "",
    party_name: order.party_name || "",
    cust_contact: order.cust_contact || "",
    order_date: order.order_date || "",
    order_status: order.order_status || "",
    order_total: order.order_total || "",
    discount: order.discount || 0,
    party_address: order.party_address || "",
    cust_address: order.cust_address || "",
    party_type: order.party_type || "",
    pay_mode: order.pay_mode || "",
    pay_status: order.pay_status || "",
    payment_id: order.payment_id || "",
    remark: order.remark || ""
  });

  setEditingCompanyId(order.id);
  setIsEditMode(true);
  setShowForm(true);
};


const handleEditItemQty = (index, value) => {
  const qty = Number(value);

  setEditItems((prevItems) => {
    const updatedItems = [...prevItems];

    updatedItems[index] = {
      ...updatedItems[index],

      qty: qty
    };

    return updatedItems;
  });
};


const handleRemoveEditItem = (index) => {

  setEditItems((prevItems) =>
    prevItems.filter(
      (_, i) => i !== index
    )
  );

};




const getItemPrice = (item) => {
  if (form.party_type === "retailer") {
    return Number(item.salePriceRetailer || 0);
  }

  if (form.party_type === "vendor") {
    return Number(item.salePriceVendor || 0);
  }

  // fallback
  return Number(item.rate || 0);
};


const getItemAmount = (item) => {
  const price = getItemPrice(item);
  const qty = Number(item.qty || 0);

  return price * qty;
};


const calculateEditOrderTotal = () => {
  return editItems.reduce((total, item) => {
    return total + getItemAmount(item);
  }, 0);
};


const getViewItemPrice = (item) => {
  if (selectedOrder?.party_type === "retailer") {
    return Number(item.salePriceRetailer || 0);
  }

  if (selectedOrder?.party_type === "vendor") {
    return Number(item.salePriceVendor || 0);
  }

  return Number(item.rate || 0);
};

const getViewItemAmount = (item) => {
  const price = getViewItemPrice(item);
  const qty = Number(item.qty || 0);

  return price * qty;
};

const getViewOrderTotal = () => {
  if (!selectedOrder) return 0;

  try {
    const items = JSON.parse(selectedOrder.items || "[]");

    return items.reduce((total, item) => {
      return total + getViewItemAmount(item);
    }, 0);
  } catch (error) {
    console.error("Failed to calculate order total:", error);
    return 0;
  }
};


return (
    <div className='main-section'>
      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

        <h3 className='my-3 fw-bold fs-5 golos'>Sale Order</h3>
        <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
          <div class="col-12 col-md-4">
            <input
              type="text"
              class="form-control"
              id="searchInput"
              placeholder="Search ...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

        </div>


          {showForm && (

          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >

                     {isEditMode && (
  <div className="card mb-3 border-0 shadow-sm">
    <div className="card-body">

      <div className="row">

        <div className="col-md-4">
          <small className="text-muted">
            Party Name
          </small>

          <div className="fw-bold">
            {form.party_name}
          </div>
        </div>

        <div className="col-md-4">
          <small className="text-muted">
            Contact
          </small>

          <div className="fw-bold">
            {form.cust_contact}
          </div>
        </div>

        <div className="col-md-4">
          <small className="text-muted">
            Order ID
          </small>

          <div className="fw-bold">
            #{form.id}
          </div>
        </div>

      </div>

    </div>
  </div>
)}

              <hr />

          <div className="mt-4">

  <h6 className="fw-bold mb-3">
    Order Items
  </h6>

  <div className="table-responsive">

    <table className="table table-bordered align-middle">

      <thead className="table-light">

        <tr>
          <th style={{ width: "60px" }}>
            SN
          </th>

          <th>
            Item
          </th>

          <th>
            Color
          </th>

          <th style={{ width: "120px" }}>
            Rate
          </th>

          <th style={{ width: "120px" }}>
            Qty
          </th>


          <th style={{ width: "70px" }}>
            Delete
          </th>
        </tr>

      </thead>

      <tbody>

        {editItems.length > 0 ? (

          editItems.map((item, index) => (

            <tr key={index}>

              <td>
                {index + 1}
              </td>

              <td>
                <div className="fw-semibold">
                  {item.name}
                </div>
              </td>

              <td>

                <div className="d-flex align-items-center gap-2">

                  <span
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor:
                        item.s_color || "#ccc",
                      border: "1px solid #999"
                    }}
                  />

                  {item.s_color}

                </div>

              </td>

              <td>₹{getItemPrice(item).toFixed(2)}

              </td>

              <td>

                <input
                  type="number"
                  min="1"
                  className="form-control form-control-sm"
                  value={item.qty}
                  onChange={(e) =>
                    handleEditItemQty(
                      index,
                      e.target.value
                    )
                  }
                />

              </td>


              <td className="text-center">

                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() =>
                    handleRemoveEditItem(index)
                  }
                >
                  <FaTrash />
                </button>

              </td>

            </tr>

          ))

        ) : (

          <tr>

            <td
              colSpan="7"
              className="text-center text-muted"
            >
              No items found
            </td>

          </tr>

        )}

      </tbody>

    </table>

  </div>

</div>

<div className="d-flex justify-content-end mt-3">
  <div
    className="border rounded p-3 shadow-sm"
    style={{ minWidth: "280px" }}
  >
    <div className="d-flex justify-content-between mb-2">
      <span className="text-muted">
        Total 
      </span>

  <strong className="text-success">
  ₹{calculateEditOrderTotal().toFixed(2)}
</strong>
    </div>

  </div>
</div>



<div className="d-flex justify-content-center gap-2 mt-4">

  <button
    type="submit"
    className="btn btn-success px-4"
  >
    <FaSave className="me-2" />
    Update
  </button>

  <button
    type="button"
    className="btn btn-danger px-4"
    onClick={() => {

      setShowForm(false);

      setIsEditMode(false);

      setEditingCompanyId(null);

      setEditItems([]);

      setForm({
        id: "",
        party_id: "",
        party_name: "",
        cust_contact: "",
        party_address: "",
        cust_address: "",
        order_date: "",
        discount: 0,
        pay_mode: "",
        pay_status: "",
        payment_id: "",
        order_total: 0,
        order_status: ""
      });

    }}
  >
    <FaTimes className="me-2" />
    Cancel
  </button>

</div>
            </form>
          </div>
        )}

        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                <th scope='col'>SN </th>
                     <th scope='col' >Action</th>
                <th scope='col'>Name</th>
                <th scope='col'>Contact</th>
                <th scope='col'> Oder Date </th>
            
                <th scope='col'>No Of Item </th>
                   <th scope='col'>Order Status </th>
              </tr>
            </thead>

            <tbody>

              {filteredData.length > 0 ? (
                filteredData.map((c, index) => {
                  let itemsArray = [];
                  try {
                    itemsArray = JSON.parse(c.items);
                  } catch (err) {
                    console.error("Failed to parse items for order", c, err);
                  }

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                       <td>
                        <FaEye title='View' size={26}
                          className="ms-2 text-info"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedOrder(c);
                            setShowViewModal(true);
                          }}
                        />


                        <HiShoppingCart title='Update Status' size={26}
                          className="ms-1 text-primary"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedOrderId(c.id);
                              setSelectedPartyId(c.party_id);
                            setShowStatusModal(true);
                          }}
                        />
{c.pay_mode == 'Cash on Delivery' && (

    <AiOutlineEdit size={26}
         className='text-warning mx-1'
     onClick={() => handleEdit(c)}
      />

                     
)}
                  
                      </td>
                      <td>{c.party_name}</td>
                      <td>{c.cust_contact}</td>
                      <td>{c.order_date}</td>
                  
                      <td>{itemsArray.length}</td>
                      <td>
  {c.return_id ? (
    <span className="badge bg-danger">{c.req_type}</span>
  ) : (
    <span className="badge bg-success">{c.order_status}</span>
  )}
</td>
                     
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No orders found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>




{showStatusModal && (
  <>
    {/* BACKDROP */}
    <div
      className="modal-backdrop fade show"
      style={{
        zIndex: 1040,
        backgroundColor: "rgba(0, 0, 0, 0.55)"
      }}
    />

    {/* MODAL */}
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ zIndex: 1050 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{
            borderRadius: "16px",
            overflow: "hidden"
          }}
        >

          {/* ================= HEADER ================= */}
          <div
            className="modal-header border-0 px-4 py-3"
            style={{
              background: "#f8f9fa"
            }}
          >
            <div className="d-flex align-items-center gap-3">

              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "12px",
                  background: "#e8f1ff",
                  color: "#0d6efd",
                  fontSize: "20px"
                }}
              >
                <FaClipboardCheck />
              </div>

              <div>
                <h5 className="mb-1 fw-semibold">
                  Update Order Status
                </h5>

                <small className="text-muted">
                  Change the current status of this order
                </small>
              </div>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowStatusModal(false);
                setSelectedStatus("");
                setRemarks("");
                setPaymentId("");
              }}
            />
          </div>


          {/* ================= BODY ================= */}
          <div className="modal-body px-4 py-4">

            {/* INFO BOX */}
            <div
              className="d-flex align-items-start gap-3 mb-4"
              style={{
                background: "#f8f9fa",
                borderRadius: "10px",
                padding: "15px"
              }}
            >
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "50%",
                  background: "#e7f1ff",
                  color: "#0d6efd"
                }}
              >
                <FaBoxOpen size={17} />
              </div>

              <div>
                <div className="fw-semibold mb-1">
                  Confirm Order Status
                </div>

                <div className="text-muted small">
                  Select the new status for this order and
                  provide any additional information if required.
                </div>
              </div>
            </div>


            {/* STATUS */}
            <div className="mb-4">

              <label className="form-label fw-semibold">
                Order Status
                <span className="text-danger ms-1">*</span>
              </label>

              <select
                className="form-select"
                value={selectedStatus}
                onChange={(e) =>
                  setSelectedStatus(e.target.value)
                }
                style={{
                  minHeight: "44px",
                  borderRadius: "8px"
                }}
              >
                <option value="">
                  Select Status
                </option>

                {statusOptions.map((status) => (
                  <option
                    key={status.value}
                    value={status.value}
                  >
                    {status.label}
                  </option>
                ))}
              </select>

            </div>


            {/* REMARKS */}
            <div className="mb-4">

              <label className="form-label fw-semibold">
                <FaCommentAlt
                  size={13}
                  className="me-2 text-muted"
                />
                Remarks
              </label>

              <textarea
                className="form-control"
                placeholder="Enter remarks..."
                value={remark}
                onChange={(e) =>
                  setRemarks(e.target.value)
                }
                rows={3}
                style={{
                  borderRadius: "8px",
                  resize: "none"
                }}
              />

              <small className="text-muted">
                Add any note related to this status update.
              </small>

            </div>


            {/* PAYMENT ID */}
            {(selectedStatus === "Return Completed" ||
              selectedStatus === "Refund Completed") && (

              <div className="mb-2">

                <label className="form-label fw-semibold">
                  <FaCreditCard
                    size={14}
                    className="me-2 text-muted"
                  />

                  Payment ID
                  <span className="text-danger ms-1">
                    *
                  </span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Payment ID"
                  value={paymentId}
                  onChange={(e) =>
                    setPaymentId(e.target.value)
                  }
                  style={{
                    minHeight: "44px",
                    borderRadius: "8px"
                  }}
                />

                <small className="text-muted">
                  Required for return or refund completion.
                </small>

              </div>
            )}

          </div>


          {/* ================= FOOTER ================= */}
          <div
            className="modal-footer border-0 px-4 py-3"
            style={{
              background: "#f8f9fa"
            }}
          >

            <button
              type="button"
              className="btn btn-outline-secondary px-4"
              onClick={() => {
                setShowStatusModal(false);
                setSelectedStatus("");
                setRemarks("");
                setPaymentId("");
              }}
              style={{
                borderRadius: "8px"
              }}
            >
              <FaTimes
                size={13}
                className="me-2"
              />

              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleStatusUpdate}
              disabled={!selectedStatus}
              style={{
                borderRadius: "8px"
              }}
            >
              <FaCheckCircle
                size={14}
                className="me-2"
              />

              Confirm Update
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)}


{showViewModal && selectedOrder && (
  <>

    <div
      className="modal-backdrop fade show"
      style={{
        backgroundColor: "rgba(0,0,0,0.65)",
        zIndex: 1040
      }}
    />


    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ zIndex: 1050 }}
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        style={{ maxWidth: "950px" }}
      >
        <div
          className="modal-content border-0"
          style={{
            background: "#f1f1f1",
            borderRadius: "4px"
          }}
        >


          <div
            className="d-flex justify-content-between align-items-center px-3 py-2"
            style={{
              background: "#343434",
              color: "#fff"
            }}
          >
            <div className="d-flex align-items-center gap-2">

              <span
                style={{
                  width: "9px",
                  height: "9px",
                  background: "#28a745",
                  borderRadius: "50%",
                  display: "inline-block"
                }}
              />

              <span className="fw-semibold">
                Order Invoice
              </span>

            </div>

            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowViewModal(false)}
            />
          </div>


  
          <div
            className="modal-body p-4"
            style={{
              background: "#e9e9e9"
            }}
          >

            <div
              ref={invoiceRef}
              className="invoice-paper mx-auto"
              style={{
                background: "#fff",
                maxWidth: "850px",
                minHeight: "900px",
                padding: "32px 34px",
                boxShadow: "0 2px 12px rgba(0,0,0,0.12)"
              }}
            >

       
              <div
                className="d-flex justify-content-between align-items-start pb-3"
                style={{
                  borderBottom: "3px solid #22a447"
                }}
              >

                {/* LEFT */}
                <div className="d-flex align-items-center">

                  <div>

                    <h3
                      className="mb-1 fw-bold"
                      style={{
                        color: "#20a345",
                        fontSize: "23px"
                      }}
                    >
                      Order Invoice
                    </h3>

                    <div
                      className="text-muted"
                      style={{ fontSize: "12px" }}
                    >
                      Customer Order
                    </div>

                  </div>

                </div>


  
                <div
                  className="text-end"
                  style={{
                    fontSize: "13px"
                  }}
                >

                  <div className="mb-1">
                    <strong>Order ID:</strong>{" "}
                    {selectedOrder.id}
                  </div>

             

                </div>

              </div>


   
              <div
                className="d-flex justify-content-between align-items-center mt-3 px-2 py-2"
                style={{
                  background: "#d7f3ed",
                  borderTop: "3px solid #20a345",
                  fontSize: "12px"
                }}
              >

                <div>
                  <strong>
                    Order No: #{selectedOrder.id}
                  </strong>
                </div>

                <div>
                  <strong>
                    Order Date: {selectedOrder.order_date}
                  </strong>
                </div>

              </div>


       
              <div className="row mt-3">

                {/* BILL TO */}
                <div className="col-md-6">

                  <h5
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    Bill To
                  </h5>

                  <div
                    style={{
                      fontSize: "12px",
                      lineHeight: "1.7"
                    }}
                  >

                    <strong>
                      {selectedOrder.party_name || "-"}
                    </strong>

                    <br />

                    Phone:{" "}
                    {selectedOrder.cust_contact || "-"}

                    <br />

                    {selectedOrder.party_address || "-"}

                  </div>

                </div>


                {/* SHIP TO */}
                <div className="col-md-6">

                  <h5
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "18px"
                    }}
                  >
                    Ship To
                  </h5>

                  <div
                    style={{
                      fontSize: "12px",
                      lineHeight: "1.7"
                    }}
                  >

                    <strong>
                      {selectedOrder.party_name || "-"}
                    </strong>

                    <br />

                    Phone:{" "}
                    {selectedOrder.cust_contact || "-"}

                    <br />

                    {selectedOrder.cust_address || "-"}

                  </div>

                </div>

              </div>


              {/* ================= ITEMS TABLE ================= */}
              <div className="mt-4">

                <table
                  className="table mb-0"
                  style={{
                    fontSize: "12px",
                    borderCollapse: "collapse"
                  }}
                >

                  <thead>

                    <tr
                      style={{
                        background: "#20a447",
                        color: "#fff"
                      }}
                    >

                      <th
                        style={{
                          width: "45px",
                          padding: "8px"
                        }}
                      >
                        #
                      </th>

                      <th style={{ padding: "8px" }}>
                        Items
                      </th>

                      <th
                        style={{
                          padding: "8px",
                          textAlign: "center"
                        }}
                      >
                        Quantity
                      </th>

                      <th
                        style={{
                          padding: "8px",
                          textAlign: "right"
                        }}
                      >
                        Rate Per Unit
                      </th>

                      <th
                        style={{
                          padding: "8px",
                          textAlign: "right"
                        }}
                      >
                        Amount
                      </th>

                    </tr>

                  </thead>


                  <tbody>

                    {(() => {

                      let parsedItems = [];

                      try {
                        parsedItems = JSON.parse(
                          selectedOrder.items || "[]"
                        );
                      } catch (error) {
                        console.error(
                          "Failed to parse order items",
                          error
                        );
                      }

                      return parsedItems.map(
                        (item, index) => {

                          let files = [];

                          try {
                            files = JSON.parse(
                              item.file || "[]"
                            );
                          } catch (error) {
                            files = [];
                          }


                          const matchedFile =
                            files.find(
                              f =>
                                String(f.color || "")
                                  .toLowerCase() ===
                                String(item.s_color || "")
                                  .toLowerCase()
                            );


                          const quantity =
                            Number(item.qty || 0);

                          const rate =
                            Number(item.rate || 0);

                          const amount =
                            quantity * rate;


                          return (
                            <tr key={index}>

                              {/* NUMBER */}
                              <td
                                style={{
                                  padding: "10px 8px",
                                  borderBottom:
                                    "1px solid #ddd"
                                }}
                              >
                                {index + 1}
                              </td>


                              {/* ITEM */}
                              <td
                                style={{
                                  padding: "8px",
                                  borderBottom:
                                    "1px solid #ddd"
                                }}
                              >

                                <div className="d-flex align-items-center">

                                  {/* {matchedFile ? (

                                    <img
                                      src={`https://api.skyguard.group/api/uploads/${matchedFile.filename}`}
                                      alt={item.name}
                                   
                                      style={{
                                        width: "38px",
                                        height: "38px",
                                        objectFit: "cover",
                                        marginRight: "10px"
                                      }}
                                    />

                                  ) : (

                                    <div
                                      style={{
                                        width: "38px",
                                        height: "38px",
                                        marginRight: "10px",
                                        background: "#eee",
                                        display: "flex",
                                        alignItems:
                                          "center",
                                        justifyContent:
                                          "center",
                                        fontSize: "9px",
                                        color: "#777"
                                      }}
                                    >
                                      N/A
                                    </div>

                                  )} */}


                                  <div>

                                    <div
                                      className="fw-semibold"
                                    >
                                      {item.name}
                                    </div>

                                    {item.s_color && (
                                      <div
                                        className="text-muted"
                                        style={{
                                          fontSize: "10px"
                                        }}
                                      >
                                        Color:{" "}
                                        {item.s_color}
                                      </div>
                                    )}

                                  </div>

                                </div>

                              </td>


                              {/* QUANTITY */}
                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "center",
                                  borderBottom:
                                    "1px solid #ddd"
                                }}
                              >
                                {quantity}
                              </td>


                              {/* RATE */}
                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "right",
                                  borderBottom:
                                    "1px solid #ddd"
                                }}
                              >
                                
                             ₹{getViewItemPrice(item).toFixed(2)}
                              </td>


                              {/* AMOUNT */}
                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "right",
                                  borderBottom:
                                    "1px solid #ddd",
                                  fontWeight: "600"
                                }}
                              >
                             ₹{getViewItemAmount(item).toFixed(2)}
                              </td>

                            </tr>
                          );

                        }
                      );

                    })()}

                  </tbody>

                </table>

              </div>


              {/* ================= SUBTOTAL LINE ================= */}
              <div
                className="d-flex justify-content-between fw-semibold"
                style={{
                  borderTop: "2px solid #62966f",
                  borderBottom: "2px solid #62966f",
                  padding: "9px 8px",
                  fontSize: "12px"
                }}
              >

                <span>
                  Sub Total
                </span>

                <span>
                  ₹
                  {Number(
                    selectedOrder.order_total || 0
                  ).toLocaleString("en-IN", {
                    minimumFractionDigits: 2
                  })}
                </span>

              </div>


              {/* ================= BOTTOM SECTION ================= */}
              <div className="row mt-4">

                {/* PAYMENT / CUSTOMER DETAILS */}
                <div className="col-md-6">

                  <div
                    style={{
                      border: "1px solid #999",
                      borderRadius: "3px",
                      padding: "10px"
                    }}
                  >

                    <h6
                      className="fw-bold mb-3"
                      style={{ fontSize: "14px" }}
                    >
                      Payment Details
                    </h6>


                    <div
                      className="d-flex justify-content-between mb-2"
                      style={{ fontSize: "11px" }}
                    >
                      <strong>
                        Payment ID:
                      </strong>

                      <span>
                        {selectedOrder.payment_id ||
                          "-"}
                      </span>
                    </div>


                    <div
                      className="d-flex justify-content-between mb-2"
                      style={{ fontSize: "11px" }}
                    >
                      <strong>
                        Payment Mode:
                      </strong>

                      <span>
                        {selectedOrder.pay_mode ||
                          "-"}
                      </span>
                    </div>


                    <div
                      className="d-flex justify-content-between"
                      style={{ fontSize: "11px" }}
                    >
                      <strong>
                        Payment Status:
                      </strong>

                      <span
                        style={{
                          color:
                            selectedOrder.pay_status ===
                            "Paid"
                              ? "#198754"
                              : "#555",
                          fontWeight: "600"
                        }}
                      >
                        {selectedOrder.pay_status ||
                          "-"}
                      </span>
                    </div>

                  </div>


                  {/* TERMS */}
                  <div className="mt-3">

                    <h6
                      className="fw-bold"
                      style={{ fontSize: "13px" }}
                    >
                      Terms & Conditions
                    </h6>

                    <div
                      className="text-muted"
                      style={{
                        fontSize: "10px",
                        lineHeight: "1.6"
                      }}
                    >
                      Order once confirmed cannot be
                      changed without approval.
                    </div>

                  </div>

                </div>


                {/* TOTALS */}
                <div className="col-md-6">

                  <div
                    style={{
                      fontSize: "12px"
                    }}
                  >

                    {/* DISCOUNT */}
                    <div
                      className="d-flex justify-content-between py-2"
                      style={{
                        borderTop:
                          "1px solid #aaa"
                      }}
                    >

                      <span>
                        Discount
                      </span>

                      <strong>
                        ₹
                        {Number(
                          selectedOrder.discount || 0
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2
                        })}
                      </strong>

                    </div>


                    {/* TOTAL */}
                    <div
                      className="d-flex justify-content-between py-2"
                      style={{
                        borderTop:
                          "1px solid #aaa"
                      }}
                    >

                      <span className="fw-bold">
                        Total Amount
                      </span>

                      <strong>
                        
                          ₹{getViewOrderTotal().toFixed(2)}
                      </strong>

                    </div>

                  </div>

                </div>

              </div>


              <div
                className="text-center mt-4 pt-3"
                style={{
                  borderTop: "2px solid #20a447",
                  fontSize: "10px",
                  color: "#777"
                }}
              >
                Thank you for your business
              </div>

            </div>

          </div>


          {/* MODAL FOOTER */}
          <div
            className="d-flex justify-content-end gap-2 px-3 py-2"
            style={{
              background: "#343434"
            }}
          >

            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => setShowViewModal(false)}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-success btn-sm"
              // onClick={() => window.print()}
                onClick={handleDownloadInvoice}
            >
              Donwload In PDF
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)}
        
      </div>
    </div>
  )
}

export default ManageOrder